module.exports = __webpack_public_path__ + "img/literasia.435acbfa.png";